import {shift} from 'constants/url';
import useUpdate from 'components/hooks/useUpdate';
import {EditingOptions} from '../../../components/grid-dx/types';

function useUpdateTurn() {
  const updateTurn = useUpdate(shift);
  return (editingOptions: EditingOptions) => updateTurn(editingOptions);
}

export default useUpdateTurn;
